import { Box, styled, Theme, Typography } from '@mui/material';
import { palette } from 'view/themes/palette';

export const RightBlockHeader = styled(Box)(({ theme }: { theme: Theme }) => {
  return {
    width: '100%',
    height: '220px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '16px 32px',
    borderRadius: '24px',
    backgroundColor: palette.background.branded_purple,
  };
});

export const HeaderTextBlock = styled(Box)(({ theme }: { theme: Theme }) => {
  return {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
  };
});

export const HeaderTitle = styled(Typography)(({ theme }: { theme: Theme }) => {
  return {
    color: palette.white,
    fontWeight: 700,
    fontSize: '32px',
    lineHeight: '38.4px',
    letterSpacing: '0',
    whiteSpace: 'pre-line',
  };
}) as typeof Typography;

export const HeaderSubTitle = styled(Typography)(({ theme }: { theme: Theme }) => {
  return {
    color: palette.white,
    fontWeight: 400,
    fontSize: '16px',
    lineHeight: '21.76px',
    letterSpacing: '0',
    whiteSpace: 'pre-line',
  };
}) as typeof Typography;
